import React from 'react'
import ScrollDown from './ScrollDown'
import ScrollRight from './ScrollRight'
import FeaturedItem from './FeaturedItem'
import RotateImage from './RotateImage'
import RevealImage from './RevealImage'

const ScrollMagic = ({ component, ...other }) => {
  if (typeof window !== 'undefined') {
    const scrollMagic = require('scrollmagic')
    switch (component) {
    default:
      return null
    case 'FEATURED_ITEM':
      return <FeaturedItem scrollMagic={scrollMagic} {...other} />
    case 'ROTATE_IMAGE':
      return <RotateImage scrollMagic={scrollMagic} {...other} />
    case 'REVEAL_IMAGE':
      return <RevealImage scrollMagic={scrollMagic} {...other} />
    case 'SCROLL_DOWN':
      return <ScrollDown scrollMagic={scrollMagic} {...other} />
    case 'SCROLL_RIGHT':
      return <ScrollRight scrollMagic={scrollMagic} {...other} />
    }
  } else {
    return null
  }
}

export default ScrollMagic
